const loadContext = (context) => context.keys().forEach(context);
const loadEntries = (entries) => entries.forEach((loadEntry) => loadEntry());
const loadGroups = (groups) => Object.values(groups).forEach((loadGroup) => loadGroup());

module.exports = {
    loadContext,
    loadEntries,
    loadGroups
};
